export type UUID = string

/**
 * Ensures that the created_at, updated_at and deleted_at timestamps of an item all contain a timezone.
 * If they don't, UTC is assumed and added.
 */
export const ensureTimezone = (item: {
  created_at: string
  updated_at: string
  deleted_at?: string | null
}) => {
  if (item.created_at) {
    if (!item.created_at.includes("Z") && !item.created_at.includes("+")) {
      item.created_at = new Date(item.created_at + "Z").toISOString()
    }
  }
  if (item.updated_at) {
    if (!item.updated_at.includes("Z") && !item.updated_at.includes("+")) {
      item.updated_at = new Date(item.updated_at + "Z").toISOString()
    }
  }
  if (item.deleted_at) {
    if (!item.deleted_at.includes("Z") && !item.deleted_at.includes("+")) {
      item.deleted_at = new Date(item.deleted_at + "Z").toISOString()
    }
  }
}

/**
 * Converts a modem serial number to a valid AWS thing name.
 *
 * thingName must satisfy [a-zA-Z0-9:_-]+
 * Ported from the provisioning tool.
 *
 * @param modemSerial
 * @returns
 */
export const getThingName = (modemSerial: string): string =>
  "sds-" + modemSerial.replaceAll(".", "_")
